/**
 * @deprecated Use GenericError going forward. class type is easier to work with than a type
 * for error handling.
 */
export type CoreError = {
  title: string;
  message: string;
  code: string | undefined;
};

export const isCoreError = (value: any): value is CoreError => {
  return 'title' in value && 'message' in value && 'code' in value;
};
